// Utilities
import axios from 'axios';

const state = {
  obj: 'working',
  new_document_object: {},
  error: '',

  margin: null,
};

const mutations = {
  SET_NEW_DOCUMENT(state, payload) {
    state.new_document_object = payload;
  },
  Auth_error(state, payload) {
    state.error = "Ce numéro de document n'existe pas";
  },
};

const actions = {
  NewDocument_Pending({ commit }, User) {
    const UserInfo = {
      userName: User.name,
      name: User.name,
      role: User.role,
      subroles: User.subroles,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/ongoingRequests',
        method: 'POST',
        data: UserInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          // commit('SET_NEW_DOCUMENT', resp.data)
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  Affecting_NewDocument({ commit }, Info) {
    const UserInfo = {
      role: Info.User.role,

      requestId: Info.requestId,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/getusersForAffect',
        method: 'POST',
        data: UserInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          // commit('SET_NEW_DOCUMENT', resp.data)
          resolve(resp);
        })
        .catch((err) => {
          commit('Auth_error', err.message);

          reject(err);
        });
    });
  },
  Affectin_To_Users({ commit }, Info) {
    const UserInfo = {
      name: Info.name,
      role: Info.User.role,

      requestId: Info.requestId,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/affectusers',
        method: 'POST',
        data: UserInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          // commit('SET_NEW_DOCUMENT', resp.data)
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  IsOpened_Pending({ commit }, UpdateInfo) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/requestopened',
        method: 'POST',
        data: UpdateInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  NewDocumentEditing_Pending({ commit }, UpdateInfo) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/updaterequestdetails',
        method: 'POST',
        data: UpdateInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
